/**
 * Centralised TanStack Query keys for the accounts resource.
 *
 * There is one read feed now, not two: balances ship on the account row, so the
 * old `trial-balance` key is gone along with the endpoint. `list` is
 * parameterised because the server resolves the account name for a requested
 * locale — a language switch is a different response and must not be served from
 * the previous language's cache entry.
 */
export const AccountQueryKeys = {
    all: ['accounts'] as const,
    /**
     * `asOf` is part of the key: balances as of two different dates are two
     * different responses, and serving one from the other's cache entry would
     * show the wrong figures with no way to tell. `null` is the live-balance
     * feed — the shape stays uniform so mutations can keep invalidating by the
     * `all` prefix.
     */
    list: (locale: string, includeArchived: boolean, asOf?: string) =>
        [
            ...AccountQueryKeys.all,
            'list',
            locale,
            includeArchived,
            asOf ?? null,
        ] as const,
    /** One account with its full locale map — what the edit drawer reads. */
    detail: (id: string) => [...AccountQueryKeys.all, 'detail', id] as const,
};
